<template>
  <v-container max-width="500px">
   <detail-card  v-if="withDC" title="Πελάτης" api="customers/" :cid="customer.Id" ></detail-card>
    <v-card class="mt-5">
      <v-card-title>
        <h1 class="mr-2 grey--text">Τιμολόγιο</h1>
      <v-spacer/>
      <v-btn icon @click="getInvoicePdf">
        <v-icon>mdi-file-pdf-box</v-icon>
      </v-btn>
      <v-btn icon @click="getPrintableInvoicePdf">
        <v-icon>mdi-printer</v-icon>
      </v-btn>
      <v-btn icon @click="getInvoiceMetadata">
        <v-icon>mdi-code-json</v-icon>
      </v-btn>
      <v-btn icon :href="invoice.Url" target="_blank">
	<v-icon>mdi-file-document</v-icon>
	</v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
        <h4 class="mr-2 my-2  subheading grey--text">Αρ. Τιμολογίου: {{ invoice.InvoiceId }}</h4>
          </v-col>
            <v-spacer></v-spacer>
          <v-col >
          <h4 class="mr-2 my-2  subheading grey--text">Οχημα: {{ invoice.PlateNumber }}</h4>
          </v-col>
          <v-col >
          <h4 class="mr-2 my-2  subheading grey--text">Πληρωμή: {{ paym[invoice.PaymTerm] }}</h4>
          </v-col>
          <v-col >
        <h4 class="mr-2 my-2 text-right subheading grey--text">Ημερομηνία: {{ invoice.Date }}</h4>
          </v-col>
        </v-row> 
        <v-row>
          <v-col>
        <h4 class="mr-2 my-2  subheading grey--text">Αρ. ΜΑΡΚ: {{ invoice.Mark }}</h4>
          </v-col>
            <v-spacer></v-spacer>
          <v-col >

          </v-col>
        </v-row> 
       <v-data-table
		:headers="showHeaders"
		:items="invoice.Lines"
		fixed-header
		dense
		height="300px"
		:items-per-page=5
		class="elevation-1"
		item-key="Id">
        <template v-slot:item.UnitPrice="{ item }">
            {{ tocurr(item.UnitPrice) }}
        </template>
        <template v-slot:item.LineGross="{ item }">
            {{ tocurr(item.LineGross) }}
        </template>
        <template v-slot:item.LineVatValue="{ item }">
            {{ tocurr(item.LineVatValue) }}
        </template>
        <template v-slot:item.LineTotalValue="{ item }">
            {{ tocurr(item.LineTotalValue) }}
        </template>
		</v-data-table>

		<v-row>
          <v-col>
        <h4 class="mr-2 my-2 text-left subheading grey--text">Σχόλια: {{ invoice.Remarks }}</h4>
          </v-col>
        </v-row>
		<v-divider></v-divider>
        <v-card :class="totalLine">
          <v-card class="elevation-0"><b>Σύνολο:</b> {{ tocurr(invoice.NetValue) }} </v-card>
          <v-card class="elevation-0"><b>ΦΠΑ 24%:</b> {{ tocurr(invoice.VatValue) }} </v-card>
          <v-card class="elevation-0"><b>Γενικό Σύνολο:</b> {{ tocurr(invoice.TotalValue) }} </v-card>
        </v-card>
      </v-card-text>

    </v-card>
  </v-container>
</template>

<script>
import DetailCard from './DetailCard.vue'
export default {
  props: {
    invoiceId: { required: true, type: String },
    withDC: {default: true },
  },
  components: {
    DetailCard,
  },
  computed: {
    showHeaders: function () {
     if (this.$vuetify.breakpoint.smAndDown) {
            return this.headers.filter(h => !(["LineVatValue", "LineTotalValue"]).includes(h.value));
        } else {
            return this.headers;
        }
    },
    totalLine () {
     if (this.$vuetify.breakpoint.smAndDown) return "d-flex justify-space-around elevation-0 py-2 mt-2"
     return "d-flex-column  text-right elevation-0 py-2 ml-2"
    },
  },
  data() {
    return {
      loading: true,
      customer: "",
      paym: {
            1: "Μετρητοίς",
            3: "Κάρτα",
            4: "Κατάθεση",
            5: "Επιταγή",
            6: "Αντικαταβολή",
            7: "Επί Πιστώσει"
      },
      invoice: { InvoiceId: "", Lines: [] },
       headers: [
      { text: 'A/A', value: 'Line', sortable: false, width: '5%' },
      { text: 'Κωδικός', value: 'ItemCode', sortable: false, width: '15%' },
      { text: 'Περιγραφή', value: 'ItemDesc', sortable: false, width: '30%' },
      { text: 'Ποσότητα', value: 'Qty', sortable: false, width: '5%' },
      //{ text: 'Μονάδα', value: 'Unit', sortable: false, width: '8%' },
      { text: 'Τιμή', value: 'UnitPrice', sortable: false },
      { text: 'Αξία', value: 'LineGross', sortable: true },
      { text: 'ΦΠΑ', value: 'LineVatValue', sortable: false },
      { text: 'Συν. Αξία', value: 'LineTotalValue', sortable: true },
      ],
    };
  },
  async created() {
    await this.fetchInvoice();
  },
  methods: {
    afm(afmnum) {
      return new String(Number(afmnum).toFixed()).padStart(9, "0");
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    async getInvoiceMetadata() {
      try {
        const response = await this.$api.get("invoices/metadata/" + this.invoice.Id);
        const metadata = response.data;
        const metadataStr = JSON.stringify(metadata, null, 2);
        const blob = new Blob([metadataStr], { type: 'application/json' });
        const fileURL = URL.createObjectURL(blob);
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `Invoice_${this.invoice.InvoiceId}_metadata.json`);
        document.body.appendChild(fileLink);
        fileLink.click();
      } catch (error) {
        console.error("Error fetching invoice metadata:", error);
      }
    },
    async getPrintableInvoicePdf() {
      try {
        const response = await this.$api.get("invoices/printable-pdf/" + this.invoice.Id, {
          responseType: "blob",
        });
        const fileURL = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        // Open in new window/tab for printing
        const printWindow = window.open(fileURL, '_blank');
        
        if (printWindow) {
          // Wait for the PDF to load, then trigger print dialog
          printWindow.onload = () => {
            printWindow.print();
          };
        } else {
          console.error("Failed to open print window. Pop-ups may be blocked.");
          // Fallback: download the PDF if print window fails
          const fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `Invoice_${this.invoice.InvoiceId}_printable.pdf`);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
        }
      } catch (error) {
        console.error("Error fetching printable invoice PDF:", error);
      }
    },
    async getInvoicePdf() {
      try {
        const response = await this.$api.get("invoices/pdf/" + this.invoice.Id, {
          responseType: "blob",
        });
        const fileURL = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `Invoice_${this.invoice.InvoiceId}.pdf`);
        document.body.appendChild(fileLink);
        fileLink.click();
      } catch (error) {
        console.error("Error fetching invoice PDF:", error);
      }
    },
    async fetchInvoice() {
      try {
        let url = "invoices/"
        if (this.invoiceId.includes("-")) url = "invoices/byid/"; 
        const response = await this.$api.get(url + this.invoiceId);
        this.invoice = response.data;
        // console.log(this.invoice);
        //this.lineitems = this.invoice.Lines;
        //console.log(this.lineitems);
        this.$store.customer = this.invoice.Customer;
        this.$store.cid = this.$store.customer.Id
        this.customer = this.invoice.Customer;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style type="text/css" media="screen">
   width: 20%;
</style>
